import { Button, Checkbox, Select, Table, message } from "antd";
import axios from "axios";
import React, { useMemo, useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { serverUrl } from "../../../../../nestserver";

const { Option } = Select;

function InstructorClass(props) {
  const queryClient = useQueryClient();
  const teacherId = props.data?.teacher?._id;
  const assignedSubjects = props.data?.teacher?.subjects || [];

  const [selectedClass, setSelectedClass] = useState();
  const [checkedSubjects, setCheckedSubjects] = useState([]);
  const [saving, setSaving] = useState(false);

  const authHeaders = {
    Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
  };

  const classes = useQuery("classes", async () => {
    const res = await axios({
      method: "get",
      url: serverUrl + "/classes/",
      headers: authHeaders,
    });
    return res.data;
  });

  const subjects = useQuery("subjects", async () => {
    const res = await axios({
      method: "get",
      url: serverUrl + "/subjects/",
      headers: authHeaders,
    });
    return res.data;
  });

  const classSubjects = useMemo(
    () =>
      (subjects.data || []).filter(
        (s) => String(s.class?._id ?? s.class) === String(selectedClass)
      ),
    [subjects.data, selectedClass]
  );

  const isTakenByOther = (subject) =>
    subject.teacher &&
    String(subject.teacher._id ?? subject.teacher) !== String(teacherId);

  const handleSelectClass = (value) => {
    setSelectedClass(value);
    setCheckedSubjects(
      assignedSubjects
        .filter((s) => String(s.class?._id ?? s.class) === String(value))
        .map((s) => s._id)
    );
  };

  const handleSave = () => {
    const keptFromOtherClasses = assignedSubjects
      .filter((s) => String(s.class?._id ?? s.class) !== String(selectedClass))
      .map((s) => s._id);

    setSaving(true);
    axios
      .patch(
        serverUrl + "/teachers/" + teacherId,
        { subjects: [...keptFromOtherClasses, ...checkedSubjects] },
        { headers: authHeaders }
      )
      .then(() => {
        message.success("Subjects assigned");
        queryClient.invalidateQueries(["instructor"]);
        queryClient.invalidateQueries("subjects");
        queryClient.invalidateQueries(["users/instructors"]);
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          message.error(err.response.data.message);
        }
      })
      .finally(() => setSaving(false));
  };

  const columns = [
    {
      title: "Subject",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Classes",
      dataIndex: ["class", "name"],
      key: "class",
      align: "center",
    },
  ];

  return (
    <>
      <div className="pt-8">
        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className=" bg-white drop-shadow-md p-5 w-full "
        >
          <div className="text-lg font-semibold pb-2">Assign Subjects</div>
          <div>
            <div className="pb-2 font-semibold">Class</div>
            <Select
              showSearch
              showArrow
              placeholder="Select Class"
              className="w-64"
              style={{ minWidth: "16rem" }}
              value={selectedClass}
              onChange={handleSelectClass}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {classes.isSuccess &&
                classes.data?.map((c) => (
                  <Option key={c._id} value={c._id}>
                    {c.name}
                  </Option>
                ))}
            </Select>

            {selectedClass &&
              (classSubjects.length > 0 ? (
                <div className="pt-4">
                  <div className="pb-2 font-semibold">Subjects</div>
                  <Checkbox.Group
                    value={checkedSubjects}
                    onChange={setCheckedSubjects}
                    className="w-full"
                  >
                    <div className="grid grid-cols-4 gap-x-6 gap-y-3">
                      {classSubjects.map((s) => (
                        <Checkbox
                          key={s._id}
                          value={s._id}
                          disabled={isTakenByOther(s)}
                          style={{ marginLeft: 0 }}
                        >
                          {s.name}
                          {isTakenByOther(s) ? " (already assigned)" : ""}
                        </Checkbox>
                      ))}
                    </div>
                  </Checkbox.Group>
                  <div className="pt-4">
                    <Button type="primary" loading={saving} onClick={handleSave}>
                      Save Subjects
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="pt-4 text-gray-500">
                  No subjects found for this class
                </div>
              ))}
          </div>
        </div>

        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className=" bg-white drop-shadow-md p-5 w-full mt-8 "
        >
          <div className="text-lg font-semibold pb-2">Assigned Subjects</div>
          <Table
            columns={columns}
            dataSource={assignedSubjects}
            rowKey="_id"
            pagination={false}
          />
        </div>
      </div>
    </>
  );
}

export default InstructorClass;
